



























































import Vue from 'vue'
import { getPatientName, hasUnaddressedLiveAlert } from '@/utils/patients'
import ResidentStatCard from '@/components/resident-summary/ResidentStatCard.vue'
import ResidentLocationCard from '@/components/resident-summary/ResidentLocationCard.vue'
import { FlatDetailedPatient } from '@/store/modules/detailed-patient/getters'
import { DetailedPatientActionNames, DetailedPatientGetterNames } from '@/store/modules/detailed-patient/keys'
import { mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { RESIDENT_STAT_TYPES } from '@/utils/resident-stat'
import { PatientWithStatsActionNames, PatientWithStatsGetterNames } from '@/store/modules/patient-with-stats/keys'
import { currentTimestamp, ONE_DAY } from '@/utils/time'
import { ActionNames, GetterNames } from '@/store/modules/patient-with-mapping-reports/keys'
import { FlatPatientWithMappingReports } from '@/store/modules/patient-with-mapping-reports/getters'
import { PatientWithStatsAttributes } from '@/jsonapi/PatientWithStats' // don't remove!
import moment from 'moment-timezone'
import MapAlert from '@/components/map/MapAlert.vue'
import { LatestVisitActionNames, LatestVisitGetterNames } from '@/store/modules/patient-with-latest-visit/keys'

export default Vue.extend({
  components: {
    MapAlert,
    ResidentStatCard,
    ResidentLocationCard,
  },
  filters: {
    getPatientName,
  },
  props: {
    patient: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loaded: false,
      statTypes: RESIDENT_STAT_TYPES,
      startTimestamp: currentTimestamp() - ONE_DAY * 7,
      endTimestamp: currentTimestamp(),
    }
  },
  computed: {
    ...mapGetters(ModuleNames.detailedPatient, [DetailedPatientGetterNames.patients]),
    ...mapGetters(ModuleNames.patientWithStats, {
      patientWithStats: PatientWithStatsGetterNames.PatientWithStats,
    }),
    ...mapGetters(ModuleNames.patientWithMappingReports, [GetterNames.patientWithMappingReports]),
    ...mapGetters(ModuleNames.patientWithLatestVisit, [LatestVisitGetterNames.patientWithLatestVisits]),

    patientWithMappingReports(): FlatPatientWithMappingReports {
      let mr = this[GetterNames.patientWithMappingReports]
      return mr.find(patientWithMR => patientWithMR.id == this.patient.id)
    },
    patientWithLatestVisit() {
      let lv = this[LatestVisitGetterNames.patientWithLatestVisits]
      return lv.find(p => p.id == this.patient.id) // should be redundant
    },
    liveEvent() {
      return this.patient && this.patient.liveEvents && this.patient.liveEvents[0]
    },
    hasUnaddressedLiveAlert() {
      return this.liveEvent && hasUnaddressedLiveAlert(this.patient.id, this.liveEvent)
    },
  },
  async mounted(): Promise<void> {
    let patientId = this.patient.id
    await this[DetailedPatientActionNames.getDetailedPatientById]({ patientId })
    await this.fetchStats({})
    await this.fetchPatientWithMappingReport()
    await this.fetchPatientWithLatestVisit({})
    this.loaded = true
  },
  methods: {
    ...mapActions(ModuleNames.detailedPatient, [DetailedPatientActionNames.getDetailedPatientById]),
    ...mapActions(ModuleNames.patientWithStats, [PatientWithStatsActionNames.getPatientWithStatsById]),
    ...mapActions(ModuleNames.patientWithMappingReports, [ActionNames.getPatientWithMappingReportsById]),
    ...mapActions(ModuleNames.patientWithLatestVisit, [LatestVisitActionNames.getPatientWithLatestVisitById]),

    detailedPatient(): FlatDetailedPatient | null {
      return this[DetailedPatientGetterNames.patients].find(p => p.id === this.patient.id)
    },
    async fetchPatientWithLatestVisit(options) {
      // use vuex state in the future
      // const p = await getPatientWithLastVisitByIdQuery(this.patient.id)
      // this.patientWithLatestVisit = p.map(patient => ({
      //   id: patient.id,
      //   ...patient.attributes,
      // }))
      await this[LatestVisitActionNames.getPatientWithLatestVisitById]({
        patientId: this.patient.id,
        startTimestamp: this.startTimestamp,
        endTimestamp: this.endTimestamp,
        ...options, // soon, add option to override timestamps
      })
    },
    async fetchStats(options): Promise<void> {
      this.loaded = false
      await this[PatientWithStatsActionNames.getPatientWithStatsById]({
        patientId: this.patient.id,
        startTimestamp: this.startTimestamp,
        endTimestamp: this.endTimestamp,
        ...options, // soon, add option to override timestamps
      })
      let patientStats = this.patientWithStats.find(pws => pws.id === this.patient.id)
    },
    async fetchPatientWithMappingReport() {
      const lastYearTimestamp = moment()
        .add(-1, 'y')
        .startOf('day')
        .valueOf()
      await this[ActionNames.getPatientWithMappingReportsById]({
        patientId: this.patient.id,
        startTimestamp: Math.max(lastYearTimestamp, this.startTimestamp),
        endTimestamp: this.endTimestamp,
      })
    },
  },
})
